import { globals } from '@/src/globals'

export const tagFilterCaseStudy = (): void => {
  const allCaseStudiesLists = document.querySelectorAll('.js-caseStudyList_2022') as unknown as HTMLElement[]

  if (allCaseStudiesLists.length === 0) {
    return
  }

  const triggerFilter = (singleTagElement: HTMLElement, allTagElements: HTMLElement[], allTargetElements: HTMLElement[]) => {
    let selectedTagIDList: string[] = []

    // Add/remove class
    if (singleTagElement.classList.contains('-active')) {
      singleTagElement.classList.remove('-active')
    } else {
      singleTagElement.classList.add('-active')
    }

    // Costruct currently active filter
    allTagElements.forEach((tagElement: HTMLElement) => {
      const dataID = tagElement.dataset.termid as string
      if (tagElement.classList.contains('-active')) {
        selectedTagIDList.push(dataID)
      } else {
        selectedTagIDList = selectedTagIDList.filter(e => e !== dataID)
      }
    })

    if (allTagElements.length <= selectedTagIDList.length) {
      selectedTagIDList = []
    }

    // Hide all elements
    allTargetElements.forEach((targetElement: HTMLElement) => {
      targetElement.classList.add('d-none')
    })

    allTargetElements.forEach((targetElement: HTMLElement) => {
      const singleStudyIDlist = (targetElement.dataset.termlist) ? JSON.parse(targetElement.dataset.termlist) : []
      let elemFound = false as boolean
      let showElement = false as boolean

      // If selectedTagIDList is empty and kill the rest of the function
      if (selectedTagIDList.length === 0 && targetElement.classList.contains('d-none')) {
        targetElement.classList.remove('d-none')
        return
      }

      // Check if ANY of the selectted IDs fits the filter set at the single case study
      singleStudyIDlist.forEach((tagID: string) => {
        // eslint-disable-next-line
        elemFound = (selectedTagIDList.find(e => e == tagID) !== undefined)
        showElement = showElement || elemFound
      })

      // Show element
      if (showElement === true && targetElement.classList.contains('d-none')) {
        targetElement.classList.remove('d-none')
      }
    })

    // Refresh all masonries
    window.dispatchEvent(new Event('resize'))
    globals.masonryList.forEach((masonry) => {
      masonry.layout()
    })
  }

  const resetFilter = (allTagElements: HTMLElement[], allTargetElements: HTMLElement[]) => {
    allTagElements.forEach((tagElement: HTMLElement) => {
      tagElement.classList.remove('-active')
    })

    allTargetElements.forEach((targetElement: HTMLElement) => {
      targetElement.classList.remove('d-none')
    })

    // Refresh all masonries
    window.dispatchEvent(new Event('resize'))
    globals.masonryList.forEach((masonry) => {
      masonry.layout()
    })
  }

  allCaseStudiesLists.forEach((caseStudiesList: HTMLElement) => {
    const allTagElements = caseStudiesList.querySelectorAll('.js-caseStudyList_2022-areaListSingle') as unknown as HTMLElement[]

    const allTargetElements = caseStudiesList.querySelectorAll('.js-caseStudyList_2022-studySingle') as unknown as HTMLElement[]

    const resetElement = caseStudiesList.querySelector('.js-caseStudyList_2022-areaListReset') as unknown as HTMLElement

    if (resetElement) {
      resetElement.addEventListener('click', () => {
        resetFilter(allTagElements, allTargetElements)
      })
    }

    allTagElements.forEach((tagElement: HTMLElement) => {
      tagElement.addEventListener('click', () => {
        triggerFilter(tagElement, allTagElements, allTargetElements)
      })
    })
  })
}
